// Autogenerated by Hanako
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Carousel } from '../../views/ts/components/Carousel';
import { Collapse } from '../../views/ts/components/Collapse';
import { Menu } from '../../views/twig/components/Menu';
import { Poster } from '../../views/twig/components/Poster';
import { FrontPage } from '../twig/pages/templates/front-page';
import { Event } from '../twig/pages/singles/event';
import { RGPDConsent } from '../../views/twig/components/RGPDConsent';
//(new AutoReload()).init();
//(new Debug()).init();
(new LazyLoader()).init();
(new Collapse()).init();
(new Carousel()).init();
(new Menu()).init();
(new Poster()).init();
(new FrontPage()).init();
(new Event()).init();
(new RGPDConsent()).init();
